export const LIGNE_ROB_UPDATE_RESET = "LIGNE_ROB_UPDATE_RESET";
export const LIGNE_ROB_UPDATE_SET_UPDATED = "LIGNE_ROB_UPDATE_SET_UPDATED";
export const LIGNE_ROB_UPDATE_SET_ERROR = "LIGNE_ROB_UPDATE_SET_ERROR";
export const LIGNE_ROB_UPDATE_TOGGLE_LOADING =
  "LIGNE_ROB_UPDATE_TOGGLE_LOADING";
